<script>
	import { page } from '$app/state';
	import '../app.scss';
	let { children } = $props();

	const theme = $derived(page.data.theme);
</script>

<div class={['outer-body', theme]}>
	<!--Christmas lights-->
	{#if new Date().getMonth() == 11}
		<div class="christmas-lights" style="margin-top: 0.5em; position: fixed; z-index: 3;">
			<ul class="lightrope">
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
			</ul>
		</div>
	{/if}
	{@render children()}
</div>
